import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'

import ClientAndPatient from '~/components/common/ClientAndPatient'
import type { Prescription } from '~/types'

import { SwapProductDialogSteps } from '../types'

import styles from './SwapProductDetails.module.scss'

export interface SwapProductDialogDetailsProps {
  prescription: Prescription
  step: SwapProductDialogSteps
}

const SwapProductDetails = ({
  prescription,
  step,
}: SwapProductDialogDetailsProps) => {
  const { t } = useTranslation('Dialogs')
  let topTitle
  let bottomTitle
  let topContent
  let bottomContent

  switch (step) {
    case SwapProductDialogSteps.CHANGE_PATIENT:
      topTitle = t('SWAP_PRODUCT_DIALOG.REQUESTED_RX_TITLE')
      bottomTitle = t('SWAP_PRODUCT_DIALOG.PATIENT_SELECTED_TITLE')
      topContent = <div className={styles.content}>{prescription.name}</div>
      bottomContent = (
        <ClientAndPatient
          loadClient
          clientId={prescription.clientId}
          patientId={prescription.patientId}
          textVariant="body2"
        />
      )
      break
    case SwapProductDialogSteps.CHANGE_PRODUCT:
      topTitle = t('SWAP_PRODUCT_DIALOG.PRESCRIPTION_FOR_TITLE')
      bottomTitle = t('SWAP_PRODUCT_DIALOG.RX_THE_PET_PARENT_SELECTED_TITLE')
      topContent = (
        <ClientAndPatient
          loadClient
          clientId={prescription.clientId}
          patientId={prescription.patientId}
          textVariant="body2"
        />
      )
      bottomContent = <div className={styles.content}>{prescription.name}</div>
      break
    default:
      break
  }

  return (
    <KibContainer className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.title}>{topTitle}</div>
        {topContent}
      </div>
      <div className={styles.innerContainer}>
        <div className={styles.title}>{bottomTitle}</div>
        {bottomContent}
      </div>
    </KibContainer>
  )
}

export default SwapProductDetails
